import React from "react"
import {Link, useParams} from "react-router-dom"
import {RepoTab} from "../../../enum/RepoTab"
import styles from "./index.module.scss"

interface RepoHeaderProps {
  repoName: string,
  displayName?: string,
  tab?: RepoTab
}

export const RepoHeader = (props: RepoHeaderProps) => {
  const {profileOrbitId, publicKey} = useParams()
  const {tab, displayName, repoName} = props

  if (!displayName || !profileOrbitId || !publicKey) {
    return null
  }

  const profileUrl = `/profile/${profileOrbitId}/${publicKey}`

  return (
    <div className={styles.Header}>
      <Link className={styles.UserProfile} to={profileUrl}>
        {displayName}
      </Link>

      <div className={styles.Separator}>
        /
      </div>

      <div className={styles.RepoName}>
        {repoName}
      </div>

      <div className={styles.OptionBar}>
        <Link to={"./codes"} className={tab === RepoTab.Codes ? styles.ActiveOption : styles.Option}>
          Codes
        </Link>
        <Link to={"./issues"} className={tab === RepoTab.Issues ? styles.ActiveOption : styles.Option}>
          Issues
        </Link>
        <Link to={"./prs"} className={tab === RepoTab.PR ? styles.ActiveOption : styles.Option}>
          PR
        </Link>
        <Link to={"./settings"} className={tab === RepoTab.Settings ? styles.ActiveOption : styles.Option}>
          Settings
        </Link>
      </div>
    </div>
  )
}
